import { map, takeUntil } from 'rxjs/operators';
import { Subject, timer } from 'rxjs';
import { Globals } from '../types/globals';
import { oauthLogger } from '../utils/logging.utils';
import { parseJwtPayload } from '../utils/jwt.util';
// TBD: Prüfen, welche Überschneidungen es mit dem Prüfen der Tokens im Session-Store gibt.
/**
 * Klasse für ein Session Handling
 * Es kann damit eine Warnung angezeigt werden, wenn die OAM Session abläuft
 */
export class SessionService {
  constructor() {
    this.stoptimer = new Subject();
    this.unsubscribe = new Subject();
    this.periodOfInMs = 10000;
    this.sessionWarntimeInMilliSec = 300;
  }
  // wird ignoriert, da die Methode lediglich für den Test notwendig ist.
  // prettier-ignore
  /* istanbul ignore next */
  /**
   * Funktion zum Aufräumen im Test
   */
  cleanUp() {
    this.stoptimer.next();
    this.stoptimer.complete();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  /**
   * Check ob Benutzer angemeldet ist
   * Wenn ja, wird der Session timer gestartet
   *
   * @param jwt
   * @param config
   */
  initJwt(jwt, config) {
    if (this.currentJwt === jwt) {
      oauthLogger.info('Das OAM-Token ist bereits im SessionService registriert!');
      return false;
    }
    oauthLogger.info('Es werden alle Events im SessionService initialisiert wegen einem neuem OAM-Token.');
    let warntime = 300;
    if (config.sessionWarntime) {
      warntime = config.sessionWarntime;
    }
    const oJwt = parseJwtPayload(jwt);
    if ((oJwt === null || oJwt === void 0 ? void 0 : oJwt.sub) != null && oJwt.sub !== 'Anonyme Benutzer') {
      /* Gültigkeit des JWT hat nichts mit User-Session zu tun! Die User-Session läuft derzeit 30min.
       Länger darf der Session-Timer nicht sein! Eine Verbesserung ist in Arbeit. Deshalb ist die Session hier nur theoretisch
       anpassbar (für Tests) und ansonsten fest auf 30 min.
       */
      // Gültigkeit aus JWT auslesen (nur für Test)
      let duration = 0;
      if (oJwt.hasOwnProperty('exp') && oJwt.hasOwnProperty('iat')) {
        duration = (oJwt.exp - oJwt.iat) * 1000;
      }
      const time = duration > 0 && duration < 1800000 ? duration : 1800000;
      this.setSession(time, warntime * 1000, {
        dueTime: 10000,
        periodOf: 10000
      });
      return true;
    }
    return false;
  }
  /**
   * Legt einen timer für die laufende OAM Session an
   * Der timer erzeugt @config.sessionWarntime Sekunden vor Ablauf der OAM Session einen Event
   * Dieser Event kann von der Anwendung behandelt werden
   */
  setSession(sessionTime, warntime, sessionTimerTimes) {
    this.sessionTimeInMs = sessionTime;
    this.sessionWarntimeInMilliSec = warntime;
    this.periodOfInMs = sessionTimerTimes.periodOf;
    // noch laufenden timer beenden
    this.stoptimer.next();
    this.warntimer = timer(sessionTime - warntime);
    this.warntimerSubscriber();
    // timer für das Alter der session
    // Event aller 10 Sekunden
    // benötigt, um Ablauf der Session festzustellen
    this.sessionAgeInMs = 0;
    this.sessiontimer = timer(sessionTimerTimes.dueTime, sessionTimerTimes.periodOf);
    this.sessiontimerSubscriber();
  }
  /**
   * Warn Event vor Session Ablauf
   */
  warntimerSubscriber() {
    this.warntimer
      .pipe(map((res) => {
      if (res === 0) {
        // Zeit bis Session Ende in Sekunden
        const warntimeInSec = this.sessionWarntimeInMilliSec / 1000;
        Globals.sessionWarning.emit(warntimeInSec.toString());
      }
    }), takeUntil(this.stoptimer))
      .subscribe();
  }
  /**
   * Session Alter erfassen
   * Event bei Session Ablauf
   */
  sessiontimerSubscriber() {
    this.sessiontimer
      .pipe(map((res) => {
      this.sessionAgeInMs = (res + 1) * this.periodOfInMs;
      // timer stoppen wenn Session abgelaufen
      if (this.sessionAgeInMs > this.sessionTimeInMs) {
        oauthLogger.info('Session ist abgelaufen! Sende Event...');
        Globals.sessionExpired.emit('sessionExpired');
        this.stoptimer.next();
      }
    }), takeUntil(this.stoptimer))
      .subscribe();
  }
}
//# sourceMappingURL=session.service.js.map
